import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { userQueryKeys } from "@/user/data/userQueryKeys";
import { ErrorResponse } from "@reflag/shared/api";
import { EntityFlagsResponse } from "@reflag/shared/flagAPI";

export function useUserFlagsData(userId?: string, enabled?: boolean) {
  const { appId, envId } = useEnvironment();

  return useQuery<EntityFlagsResponse, AxiosError<ErrorResponse>>({
    queryKey: userQueryKeys.flags(appId, envId, userId),
    queryFn: () =>
      api
        .get<"/apps/:appId/envs/:envId/users/:userId/flags">(
          `/apps/${appId}/envs/${envId}/users/${encodeURIComponent(userId!)}/flags`,
        )
        .then((res) => res.data),
    placeholderData: keepPreviousData,
    retry: (failureCount, error) => {
      if (error.response?.status === 404) {
        return false;
      }
      return failureCount < 3;
    },
    enabled: !!appId && !!envId && !!userId && enabled !== false,
  });
}
